import styled from 'styled-components';

const TestWrapper = styled.div`
  width: 100%;
  max-width: 1186px;
  margin: 0 auto;
`;

export default TestWrapper;
